import React from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { useController } from 'react-hook-form'
import { HelperText } from '.'

// This checkbox uses strings instead of bool (true/false) to decide whether the checkbox is checked or not:
// If the field.value is a string.length > 0, the checkbox will be checked (true), otherwise not (false)
// It also outputs strings instead of bool
export const HookCheckboxForStrings = ({
  name,
  control,
  defaultValue = '',
  label,
  className,
  onChange,
  disabled,
  errorStyle,
  stringValue
}) => {
  const {
    field,
    fieldState: { invalid, error }
  } = useController({
    name,
    control,
    defaultValue: defaultValue ?? ''
  })

  const handleChange = (e) => {
    const newValue = e.target.checked ? stringValue : ''
    e.target.value = newValue

    onChange?.(e)
    field.onChange(newValue)
  }

  return (
    <FormControl error={invalid}>
      <FormControlLabel
        control={
          <Checkbox
            icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
            checkedIcon={
              <CheckBoxIcon
                fontSize="large"
                style={{ fill: disabled ? 'Gray' : '#F67131' }}
              />
            }
            className={className}
            disabled={disabled}
            checked={field.value === stringValue}
            inputRef={field.ref}
            onBlur={field.onBlur}
            onChange={handleChange}
            inputProps={{
              'aria-label': label
            }}
          />
        }
        label={label}
        classes={{
          label: className
        }}
        style={{ marginBottom: 0 }}
      />
      <HelperText invalid={invalid} error={error} style={errorStyle} />
    </FormControl>
  )
}
